import React from "react";
import EmptyCartIcon from "./EmptyCartIcon";

const CartEmpty = ({ translation, onBrowse }) => (
  <div className="cart-empty">
    <div className="cart-empty__icon">
      <EmptyCartIcon className="cart-empty__illustration" />
    </div>
    <h2 className="cart-empty__title">{translation?.cartEmptyTitle}</h2>
    <p className="cart-empty__message">{translation?.cartEmptyMessage}</p>
    <button type="button" className="cart-btn cart-btn--primary cart-empty__cta" onClick={onBrowse}>
      {translation?.cartBrowseGiftCards}
    </button>
  </div>
);

export default CartEmpty;
